import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { BackendResponse, Step } from '@qtek/shared/models';

export interface WizardProgress {
  ent: 'prs' | 'acn';
  value: number;
}

export interface WizardConfig {
  children: Step[];
  meta: { progress: WizardProgress[] };
}

@Injectable({
  providedIn: 'root',
})
export class WizardService {
  private http = inject(HttpClient);

  getSteps(): Observable<BackendResponse<WizardConfig>> {
    return this.http.get<BackendResponse<WizardConfig>>('/api/v2/config/wzd', {
      withCredentials: true,
    });
  }
}
